import type { HelpFile } from '../../types/help'
import { MyDelegationsTestIds, MyDelegationsTabId } from '../../../testids/MyDelegationsTestIds'

export const myDelegationsHelp: HelpFile = {
  docPage: '/docs/my-iam/delegations',
  texts: {
    [MyDelegationsTestIds.myDelegationsPage]:
      'Temporary handovers of approval authority to a deputy — create, track, and revoke delegations here.',
    [MyDelegationsTestIds.tab(MyDelegationsTabId.Outgoing)]:
      'Delegations created here — approval authority handed over to others.',
    [MyDelegationsTestIds.tab(MyDelegationsTabId.Incoming)]:
      'Delegations granted by others — approval authority received from other users.',
    [MyDelegationsTestIds.outgoingDelegationsSection]: null,
    [MyDelegationsTestIds.incomingDelegationsSection]: null,
    [MyDelegationsTestIds.createDelegationBtn]:
      'Create a delegation — select one or more deputies and a validity period.',
    [MyDelegationsTestIds.colDelegator]: null,
    [MyDelegationsTestIds.colDeputy]: null,
    [MyDelegationsTestIds.colStartAt]:
      'Date the delegation becomes active.',
    [MyDelegationsTestIds.colEndAt]:
      'Date the delegation expires — empty if the delegation is permanent.',
    [MyDelegationsTestIds.colReason]: null,
    [MyDelegationsTestIds.colStatus]: null,
    [MyDelegationsTestIds.colWorkflowStep]:
      'Approval workflow step this delegation applies to.',
    [MyDelegationsTestIds.colActions]:
      'Row action — revoke this delegation.',
  },
}
